import Container from '../../components/Container';
import Header from '../../components/Header';
import ScanNewGuestTos from '../../components/ScanNewGuestTos';

/**
 * Landing page after a scan that didn't match an existing guest.
 * Renders the single-screen TOS + signature + accept flow that replaces
 * the legacy multi-step GuestForm chain for the scan path.
 */
const ScanNewGuestTosPage = () => {
    return (
        <Container containerName={'landing'}>
            <Header
                title={'Terms & Signature'}
                subtitle={'New guest — please review and sign:'}
                bottomBorder={true}
                padding={true}
            />
            <ScanNewGuestTos />
        </Container>
    );
};

export default ScanNewGuestTosPage;
